// Curash Wishlist Drawer — slide-out panel from the right
// build: force-push-3
(function () {
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }
  function colorHex(name) {
    var c = String(name || '').toLowerCase().trim();
    if (c.indexOf('off-white') >= 0 || c.indexOf('off white') >= 0 || c.indexOf('ivory') >= 0) return '#F8F4EA';
    if (c.indexOf('cream') >= 0) return '#F5EFE0';
    if (c.indexOf('white') >= 0) return '#FFFFFF';
    if (c.indexOf('black') >= 0 || c.indexOf('noir') >= 0 || c.indexOf('jet') >= 0) return '#111111';
    if (c.indexOf('charcoal') >= 0 || c.indexOf('graphite') >= 0) return '#36454F';
    if (c.indexOf('silver') >= 0) return '#C0C0C0';
    if (c.indexOf('grey') >= 0 || c.indexOf('gray') >= 0) return '#9CA3AF';
    if (c.indexOf('navy') >= 0) return '#1E3A5F';
    if (c.indexOf('sky') >= 0 || c.indexOf('light blue') >= 0) return '#A4D4F0';
    if (c.indexOf('teal') >= 0) return '#14B8A6';
    if (c.indexOf('blue') >= 0) return '#2563EB';
    if (c.indexOf('burgundy') >= 0 || c.indexOf('wine') >= 0) return '#722F37';
    if (c.indexOf('red') >= 0) return '#DC2626';
    if (c.indexOf('rose') >= 0 || c.indexOf('blush') >= 0) return '#F9A8B4';
    if (c.indexOf('hot pink') >= 0 || c.indexOf('fuchsia') >= 0) return '#EC4899';
    if (c.indexOf('pink') >= 0) return '#F4C2C2';
    if (c.indexOf('coral') >= 0 || c.indexOf('peach') >= 0) return '#FF8C69';
    if (c.indexOf('orange') >= 0) return '#F97316';
    if (c.indexOf('purple') >= 0 || c.indexOf('violet') >= 0) return '#7C3AED';
    if (c.indexOf('lavender') >= 0 || c.indexOf('lilac') >= 0) return '#C4B5FD';
    if (c.indexOf('sage') >= 0) return '#9CAF88';
    if (c.indexOf('olive') >= 0) return '#708238';
    if (c.indexOf('green') >= 0) return '#16A34A';
    if (c.indexOf('yellow') >= 0) return '#FCD34D';
    if (c.indexOf('gold') >= 0) return '#D4AF37';
    if (c.indexOf('tan') >= 0 || c.indexOf('sand') >= 0 || c.indexOf('camel') >= 0) return '#D2B48C';
    if (c.indexOf('nude') >= 0 || c.indexOf('beige') >= 0) return '#E8C8A8';
    if (c.indexOf('brown') >= 0) return '#92400E';
    return '#cccccc';
  }

  var drawer, body, countEl, footer;
  var wired = false;
  var clickIntercepted = false;
  var lastFocused = null;

  function setupClickIntercept() {
    if (clickIntercepted) return;
    clickIntercepted = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      // Match /pages/wishlist with optional locale prefix (e.g. /en/pages/wishlist)
      if (!/(^|\/)pages\/wishlist(\/|\?|#|$)/.test(href)) return;
      // Allow the link inside the drawer footer ("View full wishlist") to proceed normally
      if (a.closest('[data-cw-drawer]')) return;
      // If the drawer hasn't rendered for some reason, let the link navigate normally
      if (!document.querySelector('[data-cw-drawer]')) return;
      e.preventDefault();
      open();
    }, true);
  }

  function init() {
    if (wired) return;
    drawer = document.querySelector('[data-cw-drawer]');
    if (!drawer) {
      // Drawer markup hasn't rendered yet — retry until it does
      setTimeout(init, 50);
      return;
    }
    wired = true;
    body = drawer.querySelector('[data-cw-body]');
    countEl = drawer.querySelector('[data-cw-count]');
    footer = drawer.querySelector('[data-cw-footer]');

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cw-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (drawer.getAttribute('data-open') !== 'true') return;
      if (e.key === 'Escape') { close(); return; }
      // Focus trap: keep Tab cycling inside the drawer
      if (e.key === 'Tab') {
        var f = Array.prototype.slice.call(
          drawer.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])')
        ).filter(function (el) { return el.offsetParent !== null && !el.hidden; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    // Re-render whenever wishlist changes
    document.addEventListener('curash:wishlist:change', render);
    render();
  }

  // Set up click interception immediately — independent of drawer existing
  setupClickIntercept();

  function open() {
    if (!drawer) return;
    lastFocused = document.activeElement; // remember trigger to restore later
    drawer.setAttribute('data-open', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    render();
    setTimeout(function () {
      var c = drawer.querySelector('.cw-drawer__close'); // the header button (not the overlay div)
      if (c && c.focus) c.focus(); // move focus into the drawer
    }, 80);
  }

  function close() {
    if (!drawer) return;
    drawer.setAttribute('data-open', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocused && lastFocused.focus) lastFocused.focus(); // return focus
  }

  function emptyHTML() {
    return ''
      + '<div class="cw-drawer__empty">'
      +   '<svg class="cw-drawer__empty-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2">'
      +     '<path stroke-linecap="round" stroke-linejoin="round" d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>'
      +   '</svg>'
      +   '<h3 class="cw-drawer__empty-title">Nothing saved yet</h3>'
      +   '<p class="cw-drawer__empty-text">Tap the heart on any piece to keep it close.</p>'
      +   '<a href="/" class="cw-drawer__shop">Browse new arrivals →</a>'
      + '</div>';
  }

  function itemHTML(it) {
    var url = it.url || ('/products/' + (it.handle || ''));
    var primaryColor = '';
    if (it.colors) {
      var first = String(it.colors).split('|')[0];
      if (first) primaryColor = first.trim();
    }
    var variantHtml = '';
    if (primaryColor) {
      variantHtml = '<div class="cw-item__variant">'
        +   '<span class="cw-item__variant-dot" style="background-color: ' + colorHex(primaryColor) + ';"></span>'
        +   '<span>' + esc(primaryColor) + '</span>'
        + '</div>';
    }
    return ''
      + '<article class="cw-item" data-cw-id="' + esc(it.id) + '">'
      +   '<a href="' + esc(url) + '" class="cw-item__media">'
      +     '<img src="' + esc(it.image || '') + '" alt="' + esc(it.title || '') + '" loading="lazy" />'
      +   '</a>'
      +   '<div class="cw-item__info">'
      +     '<a href="' + esc(url) + '" class="cw-item__title">' + esc(it.title || '') + '</a>'
      +     variantHtml
      +     '<div class="cw-item__price">' + esc(it.price || '') + '</div>'
      +     '<button type="button" class="cw-item__quick-add" data-cw-quick-add data-cw-handle="' + esc(it.handle || '') + '">Add to bag</button>'
      +   '</div>'
      +   '<button type="button" class="cw-item__remove" data-cw-remove aria-label="Remove">'
      +     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>'
      +   '</button>'
      + '</article>';
  }

  function render() {
    if (!body || !window.CurashWishlist) return;
    var items = window.CurashWishlist.list();
    var n = items.length;
    if (countEl) countEl.textContent = n ? '(' + n + ')' : '';
    if (footer) footer.hidden = n === 0;

    if (n === 0) {
      body.innerHTML = emptyHTML();
      return;
    }

    body.innerHTML = items.map(itemHTML).join('');

    body.querySelectorAll('[data-cw-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-cw-id]');
        if (!card) return;
        var id = card.getAttribute('data-cw-id');
        // Animate out then re-render
        card.style.transition = 'opacity 0.2s ease, transform 0.2s ease';
        card.style.opacity = '0';
        card.style.transform = 'translateX(20px)';
        setTimeout(function () {
          window.CurashWishlist.remove(id);
        }, 180);
      });
    });

    body.querySelectorAll('[data-cw-quick-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var handle = btn.getAttribute('data-cw-handle');
        var id = btn.closest('[data-cw-id]').getAttribute('data-cw-id');
        if (!window.CurashQuickAdd) return;
        // Pull stored productData so the modal works even with password gate
        var stored = window.CurashWishlist.list().filter(function (it) { return String(it.id) === String(id); })[0];
        var productData = null;
        if (stored && stored.productData) {
          try { productData = JSON.parse(stored.productData); } catch (e) { productData = null; }
        }
        close();
        // Small delay so the close animation finishes before the modal opens
        setTimeout(function () {
          window.CurashQuickAdd.open(handle, productData);
        }, 200);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.CurashWishlistDrawer = { open: open, close: close };
})();
